import * as LDClient from 'launchdarkly-js-client-sdk';
import {resetFeatureFlags} from '../ducks/featureFlags';
import ReduxStore from '../ReduxStore';
import {isNZLocale} from './PropertyUtils';

let ldClient;

const LaunchDarklyGateway = {
  initialize: () => {
    const ldKey = isNZLocale()
      ? window.ENV.LAUNCH_DARKLY_KEY_NZ
      : window.ENV.LAUNCH_DARKLY_KEY_AU;

    if (!ldKey) {
      console.warn('LaunchDarkly key is not configured. Skipping initialization.');
      return;
    }

    ldClient = LDClient.initialize(
      ldKey,
      { key: 'anonymous' },
      LaunchDarklyGateway.updateAllFeatureFlags
    );
    ldClient.on('ready', LaunchDarklyGateway.updateAllFeatureFlags);
    ldClient.on('change', LaunchDarklyGateway.updateAllFeatureFlags);
  },

  updateUser(data) {
    if (data.username) {
      if (ldClient) {
        const { username, workEmail, firstName, lastName, ...custom } = data;

        return ldClient
          .identify(
            {
              key: username,
              name: username,
              email: workEmail,
              firstName,
              lastName,
              custom,
            },
            null
          ).then(LaunchDarklyGateway.updateAllFeatureFlags);
      } else {
        setTimeout(this.updateUser, 100, data);
      }
    }
  },

  updateAllFeatureFlags() {
    ReduxStore.dispatch(resetFeatureFlags(ldClient.allFlags()));
  },

  initialised() {
    return ldClient;
  },
};

export default LaunchDarklyGateway;
